






































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_fbBookkeepingAccounts_fbBookkeepingAccounts } from '@/queries/__generated__/fbBookkeepingAccounts';
import { GQL_ameldingAccountSelections } from '@/queries/__generated__/ameldingAccountSelections';
import { GQL_AmeldingAccountSelectionSave } from '@/queries/global';
import gql from 'graphql-tag';

const AMELDING_ACCOUNT_SELECTIONS = gql`
  query ameldingAccountSelections {
    currentUnit {
      id
      ameldingAccountSelections { id number employeeTaxDeduction }
    }
  }
`;

interface IFormAccount {
  _destroy: boolean | undefined;
  name: string;
  number: string;
  id: string | undefined;
}

@Component({})
export default class BookkeepingSetup extends Vue {
  @Prop() private allAccounts!: GQL_fbBookkeepingAccounts_fbBookkeepingAccounts[];

  private selections: IFormAccount[] = [];
  private ftrSelectionNumber: string | null = null;
  private selectedAccountNumber: string | null = null;

  private debug = false;

  private beforeCreate() {
    this.$apollo.query({
      query: AMELDING_ACCOUNT_SELECTIONS,
      fetchPolicy: 'no-cache',
    }).then((resp) => {
      const data = resp.data as GQL_ameldingAccountSelections;
      const selections = data.currentUnit.ameldingAccountSelections;

      const ftrSelection = selections.find(sel => sel.employeeTaxDeduction);
      if (ftrSelection) { this.ftrSelectionNumber = ftrSelection.number }

      selections.forEach(sel => {
        this.addAccount({
          id: sel.id,
          number: sel.number,
          name: this.nameForNum(sel.number),
          _destroy: false,
        });
      });
    });
  }

  private get visibleSelections() {
    return this.selections.filter(sel => !sel._destroy);
  }

  private get nonSelectedAccounts() {
    const selectedNumbers = this.visibleSelections.map(sel => sel.number);
    return this.allAccounts.filter(acc => !selectedNumbers.includes(acc.number));
  }

  public serializeAccounts(): GQL_AmeldingAccountSelectionSave[] {
    const selectionData = this.selections.map(selection => {
      const isDeduction = this.ftrSelectionNumber === selection.number;

      if (selection._destroy) {
        return {
          id: selection.id,
          _destroy: true,
        };
      } else if (selection.id) {
        return {
          id: selection.id,
          number: selection.number,
          employeeTaxDeduction: isDeduction,
        };
      } else {
        return {
          number: selection.number,
          employeeTaxDeduction: isDeduction,
        };
      }
    });
    return selectionData;
  }

  private addAccount(account: IFormAccount) {
    const restoreFromDestruction = this.selections.find(sel => sel.number == account.number);

    if (restoreFromDestruction && restoreFromDestruction._destroy === true) {
      restoreFromDestruction._destroy = false;
    } else {
      this.selections.push(account);
    }

    this.selectedAccountNumber = null;
  }

  private markForDestruction(account: IFormAccount) {
    if (!account.id) {
      // delete the item from the array
      this.selections.splice(this.selections.findIndex(sel => sel.number == account.number), 1);
    } else {
      account._destroy = true;
    }
  }

  private setFtr(account: IFormAccount) {
    this.ftrSelectionNumber = account.number;
  }

  private nameForNum(accNum: string): string {
    const account = this.allAccounts.find(acc => acc.number == accNum);
    if (!account) return '';

    return account.name;
  }
}
